<p>
  <mat-slide-toggle
    data-testid="enable-short-links"
    color="primary"
    [(ngModel)]="data.shortener_is_active"
    (ngModelChange)="subConfigChanged.emit()">
    <span translate="account/links/shortener/activate-shortener"></span>
  </mat-slide-toggle>
</p>

<section>
  <h5 translate="account/links/exceptions"></h5>
  <div *ngFor="let exception of data.exceptions; index as index">
    <mat-form-field>
      <mat-label translate="account/links/config_edition/exception_url_label"></mat-label>
      <input matInput [(ngModel)]="exception.url" (ngModelChange)="subConfigChanged.emit()" type="text" />
    </mat-form-field>
    <button (click)="deleteException(index)" mat-icon-button color="primary" aria-label="delete exception">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
  <div>
    <button
      (click)="addException()"
      mat-raised-button
      color="accent"
      translate="account/links/exceptions/add"
      aria-label="add exception"></button>
  </div>
</section>

<section class="transformations">
  <h5 translate="account/links/transformations"></h5>
  <div *ngFor="let transformation of data.transformations; index as index">
    <span [attr.data-testid]="'transformation-' + index" flex>{{ transformation.hostname }}</span>

    <button (click)="editTransformation(index)" mat-icon-button color="primary" aria-label="edit transformation">
      <mat-icon>edit</mat-icon>
    </button>
    <button (click)="deleteTransformation(index)" mat-icon-button color="primary" aria-label="delete transformation">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
  <button
    (click)="addTransformation()"
    mat-raised-button
    color="accent"
    translate="account/links/transformations/add"
    [attr.aria-label]="'account/links/transformations/add' | translate"></button>
</section>
